import { NotificationRow } from '../../types/account/NotificationRow';

export const isFee = (x: NotificationRow) => x.type && x.type.endsWith('Fee');
